import React from 'react';
import { CalendarIcon } from '@heroicons/react/24/outline';

const Events: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Events</h1>
      <p className="section-description">
        Manage and organize events with comprehensive details including scheduling, location, ticketing, and status management.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <CalendarIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Event Management</h3>
              <p className="feature-description">
                Create and manage events with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create and edit event details</li>
                <li>Upload event images</li>
                <li>Manage event status (Draft, Upcoming, Completed, Cancelled)</li>
                <li>Control event visibility (Public/Private)</li>
                <li>Delete individual events</li>
                <li>Bulk delete multiple events</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <CalendarIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Event Details</h3>
              <p className="feature-description">
                Comprehensive event information management:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Title and description</li>
                <li>Organizer selection</li>
                <li>Category and tags</li>
                <li>Start and end times with timezone</li>
                <li>Venue and address details</li>
                <li>Capacity and ticketing options</li>
                <li>Event image upload</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <CalendarIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Event List</h3>
              <p className="feature-description">
                View and manage events in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Title (searchable)</li>
                <li>Start time (sortable)</li>
                <li>Venue (defaults to "Online")</li>
                <li>Capacity (formatted number)</li>
                <li>Ticket price (formatted currency)</li>
                <li>Status (color-coded badges)</li>
                <li>Public status (boolean toggle)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <CalendarIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Quick Actions</h3>
              <p className="feature-description">
                Available actions for managing events:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Publish draft events</li>
                <li>Edit event details</li>
                <li>Delete events</li>
                <li>Bulk publish multiple events</li>
                <li>Bulk delete multiple events</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Keep event information up to date and accurate</li>
            <li>Use high-quality images for event promotion</li>
            <li>Set appropriate capacity limits for venue constraints</li>
            <li>Regularly update event status to reflect current state</li>
            <li>Use tags and categories for better event organization</li>
            <li>Ensure timezone information is correct for international events</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Events; 